angular
  .module('major-explorer-data')
  .constant('MyIntakeModelDTD', {
    root: {
      optional: true,
      type: 'object'
    },
    source: {
      optional: true,
      type: 'object'
    },
    pages: {
      optional: true,
      type: 'array'
    }
  })
  .provider('myIntakeModel', function myIntakeModelProvider(ngProgression, MyIntakeModelDTD) {
    var configuration = {
      createProgression: function (model) {
        // 4 -> [0, 1, 2, 3]
        return new ngProgression(_.size(model.pages));
      }
    };

    this.configure = function configure_myIntakeModel(config) {
      if (config) {
        configuration = _.merge({}, configuration, config);
      }
      return configuration;
    };

    const MyIntakeModel = function MyIntakeModel(Interface) {
      this.initialize = function initialize(intakeItem) {
        Interface.implement(MyIntakeModelDTD, {}, this);

        this.source = intakeItem;
        this.root = intakeItem.root;
        this.pages = splitOutPages(intakeItem.root);
        this.progression = configuration.createProgression(this);
        this.status = this.root._task.status;
        this.hasNotStarted = false;
        return this;
      };

      const splitOutPages = function splitOutPages(root) {
        return _.map(root.children, function (childrenPage) {
          return childrenPage;
        });
      };

      this.splitOutRankPage = function splitOutRankPage() {
        this.pages = splitOutChildPages(this.pages);
        this.progression = configuration.createProgression(this);
      };

      function splitOutChildPages(pages) {
        let res = [];
        pages.forEach((page) => {
          page.children.length > 1 ? res.push(...flattenChildPages(page)) : res.push(page);
        });
        return res;
      }

      function flattenChildPages(page) {
        let pageChildren = page.children;
        return pageChildren.map((child) => {
          return _.assign({}, page, {
            children: [child]
          });
        });
      }

      this.setCurrentPageIndex = function setCurrentPageIndex(pageIndex) {
        this.progression.index = parseInt(pageIndex, 10);
        return this;
      };

      this.getCurrentPage = function getCurrentPage() {
        // TODO make sure we never read progression.index, but use progression.current()
        return this.pages[this.progression.current()];
      };

      this.setHasNotStarted = function setIsPreStart(notStarted) {
        this.hasNotStarted = notStarted;
      };
    };

    this.$get = function $get_myIntakeModel(Interface) {
      return new MyIntakeModel(Interface);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/models/my_intake_model.es.js